import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Twitter, Linkedin, Instagram, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
export function Footer() {
  return <footer className="relative bg-charcoal text-white overflow-hidden" data-id="element-99">
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 md:py-20" data-id="element-100">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 sm:gap-12 mb-12" data-id="element-101">
          {/* Brand Column */}
          <div className="sm:col-span-2 lg:col-span-1" data-id="element-102">
            <Link to="/" className="inline-block mb-6" data-id="element-103">
              <motion.img whileHover={{
              scale: 1.05
            }} transition={{
              duration: 0.3
            }} src="https://cdn.magicpatterns.com/uploads/k5fNtmwc2mFs1AhwSeu33E/FDF_Gold_Logo.png" alt="FDF Gold Concept Nigeria Limited - Company Logo" className="h-12 sm:h-14 w-auto object-contain brightness-0 invert" style={{
              filter: 'brightness(0) invert(1) drop-shadow(0 2px 4px rgba(255, 255, 255, 0.1))',
              maxWidth: '180px'
            }} data-id="element-104" />
            </Link>
            <p className="text-white/60 mb-6 leading-relaxed text-sm sm:text-base" data-id="element-105">
              Building Excellence, Engineering the Future. Your trusted partner
              in construction and engineering solutions.
            </p>
            <div className="flex gap-3" data-id="element-106">
              {[Facebook, Twitter, Linkedin, Instagram].map((Icon, index) => <motion.a key={index} href="#" whileHover={{
              scale: 1.1
            }} whileTap={{
              scale: 0.95
            }} className="w-10 h-10 bg-white/5 hover:bg-gold/20 border border-white/10 hover:border-gold/30 flex items-center justify-center text-white/60 hover:text-gold transition-all" data-id="element-107">
                  <Icon size={18} strokeWidth={1.5} data-id="element-108" />
                </motion.a>)}
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-109">
            <h3 className="font-heading font-semibold text-base sm:text-lg mb-6" data-id="element-110">
              Quick Links
            </h3>
            <ul className="space-y-3" data-id="element-111">
              {[{
              to: '/about',
              label: 'About Us'
            }, {
              to: '/services',
              label: 'Services'
            }, {
              to: '/portfolio',
              label: 'Portfolio'
            }, {
              to: '/equipment',
              label: 'Equipment'
            }].map(link => <li key={link.to} data-id="element-112">
                  <Link to={link.to} className="group flex items-center gap-2 text-white/60 hover:text-gold transition-colors text-sm sm:text-base" data-id="element-113">
                    <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" strokeWidth={2} data-id="element-114" />
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Company */}
          <div data-id="element-115">
            <h3 className="font-heading font-semibold text-base sm:text-lg mb-6" data-id="element-116">
              Company
            </h3>
            <ul className="space-y-3" data-id="element-117">
              {[{
              to: '/csr',
              label: 'CSR'
            }, {
              to: '/qaqc',
              label: 'Quality Assurance'
            }, {
              to: '/hse',
              label: 'Health & Safety'
            }, {
              to: '/contact',
              label: 'Contact Us'
            }].map(link => <li key={link.to} data-id="element-118">
                  <Link to={link.to} className="group flex items-center gap-2 text-white/60 hover:text-gold transition-colors text-sm sm:text-base" data-id="element-119">
                    <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" strokeWidth={2} data-id="element-120" />
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Contact Info */}
          <div data-id="element-121">
            <h3 className="font-heading font-semibold text-base sm:text-lg mb-6" data-id="element-122">
              Get In Touch
            </h3>
            <ul className="space-y-4" data-id="element-123">
              <li className="flex items-start gap-3 text-white/60 text-sm sm:text-base" data-id="element-124">
                <MapPin size={20} className="text-gold flex-shrink-0 mt-0.5" strokeWidth={1.5} data-id="element-125" />
                <span data-id="element-126">Abuja, Nigeria</span>
              </li>
              <li className="flex items-center gap-3 text-white/60 hover:text-gold transition-colors text-sm sm:text-base" data-id="element-127">
                <Phone size={20} className="text-gold flex-shrink-0" strokeWidth={1.5} data-id="element-128" />
                <a href="tel:+234" data-id="element-129">+234 XXX XXX XXXX</a>
              </li>
              <li className="flex items-center gap-3 text-white/60 hover:text-gold transition-colors text-sm sm:text-base" data-id="element-130">
                <Mail size={20} className="text-gold flex-shrink-0" strokeWidth={1.5} data-id="element-131" />
                <a href="mailto:info@fdfgold.com" data-id="element-132">info@fdfgold.com</a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8" data-id="element-133">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4 text-sm text-white/50" data-id="element-134">
            <p className="text-center sm:text-left" data-id="element-135">
              © {new Date().getFullYear()} FDF Gold Concept Nigeria Limited.
              All rights reserved.
            </p>
            <div className="flex gap-6" data-id="element-136">
              <a href="#" className="hover:text-gold transition-colors" data-id="element-137">
                Privacy Policy
              </a>
              <a href="#" className="hover:text-gold transition-colors" data-id="element-138">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}